import { createSlice, current } from '@reduxjs/toolkit';
import { getMails, addMail, updateMail, deleteMail } from '../thunks/mails';

export const mailsSlice = createSlice({
  name: 'mails',
  initialState: {
    mails: [],
    isFetching: false,
    isAdding: false,
    isUpdating: {},
  },

  reducers: {},

  extraReducers: {
    [getMails.pending]: (state, action) => {
      state.isFetching = true;
    },
    [getMails.fulfilled]: (state, action) => {
      state.isFetching = false;
      state.mails = action.payload;
    },
    [getMails.rejected]: (state, action) => {
      state.isFetching = false;
    },

    [addMail.pending]: (state, action) => {
      state.isAdding = true;
    },
    [addMail.fulfilled]: (state, action) => {
      state.mails.push(action.payload);
      state.isAdding = false;
    },
    [addMail.rejected]: (state, action) => {
      state.isAdding = false;
    },

    [updateMail.pending]: (state, action) => {
      state.isUpdating[action.meta.arg.id] = true;
    },
    [updateMail.fulfilled]: (state, action) => {
      const { _id, email } = action.payload;
      const currentState = current(state);
      state.mails = currentState.mails.map(mail => mail._id === _id ? { ...mail, email } : mail);
      state.isUpdating[_id] = false;
    },
    [updateMail.rejected]: (state, action) => {
      state.isUpdating[action.meta.arg.id] = false;
    },

    [deleteMail.fulfilled]: (state, action) => {
      const currentState = current(state);
      state.mails = currentState.mails.filter(mail => mail._id !== action.payload);
    }
  }
});

export default mailsSlice.reducer;
